export default __webpack_public_path__ + "static/media/Sliver of Pure Ice (wisdom).eb922f04.jpg";